// extracted by mini-css-extract-plugin
export default {"btn":"PageHelpButton_btn__v26Nu"};